import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { MaterialModule } from 'src/app/shared/modules/material.module';
import { SavedModule } from 'src/app/features/saved/saved.module';

import { DataSourcesComponent } from './pages/data-sources/data-sources.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';

const exportComponents = [HeaderComponent, FooterComponent];

@NgModule({
  imports: [CommonModule, RouterModule, MaterialModule, SavedModule],
  exports: [...exportComponents],
  declarations: [...exportComponents, DataSourcesComponent, PrivacyPolicyComponent]
})
export class CoreModule {}
